import React, { useState, useEffect } from 'react';
import { MathJax } from "better-react-mathjax";

import style from './Hints.css';


function Hints({ onClose, hintsArray }) {

    const [activeHintIndex, setActiveHintIndex] = useState(0);
    // const hintArray = ['$sum_(i=1)^n(s_n/lambda_n) 1$', '$sum_(i=1)^n(s_n/lambda_n) 2$', '$sum_(i=1)^n(s_n/lambda_n) 3$'];

    const prevHint = () => {
      setActiveHintIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };
  
    const nextHint = () => {
      setActiveHintIndex(prevIndex => (prevIndex < hintsArray.length - 1 ? prevIndex + 1 : prevIndex));
    };

    const handleKeyDown = (event) => {
        if (event.keyCode === 39) { // Right arrow key
          nextHint();
        } else if (event.keyCode === 37) { // Left arrow key
          prevHint();
        }
      };
    
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
    
        return () => {
          document.removeEventListener('keydown', handleKeyDown);
        };
    }, []); // Empty dependency array to ensure the event listener is added and removed only once

    return (
    <div className="hints-div" onClick={onClose}>
        <span className="close" onClick={onClose}>&times;</span>
        <div className="hints-div-content" onClick={e => e.stopPropagation()}>
        <div className="hint-counter">{activeHintIndex + 1}/{hintsArray.length} 💡</div>
            {hintsArray.map((hint, index) => (
            <div key={index} className={`hint-page ${index === activeHintIndex ? 'active' : ''}`}>
                    <MathJax dynamic>
                          <div style={{ textAlign: "center" }} id="hints-formulas">
                              <p style={{ whiteSpace: "pre-line" }}>{hintsArray}</p>
                          </div>
                    </MathJax>{" "}
            </div>
            ))}
            <a className="arrow-button left" onClick={prevHint}>&#10094;</a>
            <a className="arrow-button right" onClick={nextHint}>&#10095;</a>
        </div>
    </div>
  );
}

export default Hints;
